import { PDFDownloadLink } from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import styled from "styled-components";
import InvoicePdf from "../../views/Checkout/InvoicePdf";
import { OrderModel } from "../../views/Checkout/OrderInterfaces";
import Button from "../Button/Button";
import assetsConfig from "../../assetsConfig";
import { getInvoiceLabels } from "../../utils/getLabels";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

const StyledDownloadLink = styled(PDFDownloadLink)`
	text-decoration: none;
	color: ${({ theme }) => theme.colorCopyDarkDark};
`;

const DownloadPDF = (props: DownloadPDFProps) => {
	const [fileName, setFileName] = useState(
		assetsConfig.companyNameShort + " Order",
	);
	const [labels, setLabels] = useState<Record<string, string> | null>(null);
	const { settings } = useSelector((state: RootState) => state.settings);
	const countryIso = settings.countryIso;

	useEffect(() => {
		if (props.order && props.order.id) {
			setFileName(assetsConfig.companyNameShort + " Order " + props.order.id);
		}
	}, [props.order]);

	useEffect(() => {
		getInvoiceLabels().then(setLabels);
	}, []);

	return (
		<>
			{props.order && labels && (
				<Button className="button-light">
					<StyledDownloadLink
						document={
						<InvoicePdf
							order={props.order}
							labels={labels}
							countryIso={countryIso}
							companyTaxId={props.order.taxId}
							showInvoiceNotes={settings.featureFlags["Invoice Notes"]}
						/>
						}
						fileName={fileName}
					>
						{({ blob, url, loading, error }) =>
							loading
								? "Loading document..."
								: props.title
									? props.title
									: "Download Order"
						}
					</StyledDownloadLink>
				</Button>
			)}
		</>
	);
};

interface DownloadPDFProps {
	order: OrderModel | undefined;
	title?: string;
}

export default DownloadPDF;
